<ng-content select="[brMenuItemPrefix]"></ng-content>
<br-icon *ngIf="icon">{{ icon }}</br-icon>
<span>{{ item.typeaheadLabel }}</span>
